import { render, staticRenderFns } from "./diseases.vue?vue&type=template&id=2c69a3c9&scoped=true"
import script from "./diseases.vue?vue&type=script&lang=js"
export * from "./diseases.vue?vue&type=script&lang=js"
import style0 from "./diseases.vue?vue&type=style&index=0&id=2c69a3c9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c69a3c9",
  null
  
)

export default component.exports